import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { IFiChecklistCheckpointModel } from '@fi-shared/checklist';

@Component({
    selector: 'fi-checklist-checkpoint-mandatory-info',
    template: '{{getText()}}',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checkpoint-mandatory-info.component.scss'],
    standalone: false,
})
export class FiChecklistCheckpointMandatoryInfo {
    @Input() checkpoint: IFiChecklistCheckpointModel;

    @HostBinding('class.error')
    @Input()
    error: boolean = false;

    constructor(private appTextService: AppTextService) {}

    getText() {
        if (!this.checkpoint) return '';
        const parts = [];

        if (
            this.checkpoint.IsAttachmentMandatoryOk &&
            !this.checkpoint.IsAttachmentMandatoryNotOk &&
            this.checkpoint.IsCommentMandatoryOk &&
            !this.checkpoint.IsCommentMandatoryNotOk
        ) {
            parts.push(this.appTextService.get('checklist.attachment_and_comment_mandatory_for_ok'));
        } else if (
            !this.checkpoint.IsAttachmentMandatoryOk &&
            this.checkpoint.IsAttachmentMandatoryNotOk &&
            !this.checkpoint.IsCommentMandatoryOk &&
            this.checkpoint.IsCommentMandatoryNotOk
        ) {
            parts.push(this.appTextService.get('checklist.attachment_and_comment_mandatory_for_not_ok'));
        } else {
            if (this.checkpoint.IsAttachmentMandatoryOk && this.checkpoint.IsAttachmentMandatoryNotOk)
                parts.push(this.appTextService.get('checklist.attachment_mandatory_for_ok_and_not_ok'));
            else if (this.checkpoint.IsAttachmentMandatoryOk)
                parts.push(this.appTextService.get('checklist.attachment_mandatory_for_ok'));
            else if (this.checkpoint.IsAttachmentMandatoryNotOk)
                parts.push(this.appTextService.get('checklist.attachment_mandatory_for_not_ok'));

            if (this.checkpoint.IsCommentMandatoryOk && this.checkpoint.IsCommentMandatoryNotOk)
                parts.push(this.appTextService.get('checklist.comment_mandatory_for_ok_and_not_ok'));
            else if (this.checkpoint.IsCommentMandatoryOk)
                parts.push(this.appTextService.get('checklist.comment_mandatory_for_ok'));
            else if (this.checkpoint.IsCommentMandatoryNotOk)
                parts.push(this.appTextService.get('checklist.comment_mandatory_for_not_ok'));
        }

        const str = parts.join(', ');

        return str.length > 1 ? str[0].toUpperCase() + str.slice(1).toLowerCase() : '';
    }
}
